module.exports.createRemoveLineItemAction = (product) => ({
  removeLineItem: {
    lineItemId: product.id,
    quantity: product.quantity,
  },
});
